export const bookingSystemVersion = 1;
